export default __webpack_public_path__ + "static/media/payroll.620d5ac1.png";